import { useTranslation } from 'react-i18next'
import { format, parseISO } from 'date-fns'
import { DashboardSection } from './DashboardSection'
import type { DashboardLastMonth } from '../../types/dashboard'

function StatRow({ label, value }: { label: string; value: string }) {
  return (
    <div className="flex items-baseline justify-between gap-2 border-b border-border/60 py-2 last:border-b-0">
      <span className="text-sm text-muted-foreground">{label}</span>
      <span className="text-sm font-semibold tabular-nums">{value}</span>
    </div>
  )
}

interface LastMonthStatsProps {
  lastMonth: DashboardLastMonth
}

export function LastMonthStats({ lastMonth }: LastMonthStatsProps) {
  const { t } = useTranslation()

  return (
    <DashboardSection title={t('dashboard.lastMonth.title')}>
      <div className="rounded-xl border px-3 py-1">
        {/* On-sight is impossible on a boulder, so the row only earns its place
            when the climber actually has one. */}
        {lastMonth.on_sight > 0 && (
          <StatRow
            label={t('trainingDiary.ascentSendType.on_sight')}
            value={String(lastMonth.on_sight)}
          />
        )}
        <StatRow label={t('trainingDiary.ascentSendType.flash')} value={String(lastMonth.flash)} />
        <StatRow label={t('dashboard.lastMonth.workedNd')} value={String(lastMonth.worked_nd)} />
        <StatRow
          label={t('dashboard.lastMonth.lastWorkout')}
          value={
            lastMonth.last_workout_date
              ? format(parseISO(lastMonth.last_workout_date), 'dd/MM')
              : '—'
          }
        />
        <StatRow
          label={t('dashboard.lastMonth.workoutsCount')}
          value={String(lastMonth.workouts_count)}
        />
      </div>
    </DashboardSection>
  )
}
